// extracted by mini-css-extract-plugin
export var button = "_1e-0";
export var buttonContent = "_1e-e";
export var buttonGroup = "_1e-c";
export var dontRestrainIconWidth = "_1e-a";
export var dropdownButton = "_1e-b";
export var iconContainer = "_1e-9";
export var lg = "_1e-4";
export var md = "_1e-3";
export var pending = "_1e-f";
export var sm = "_1e-2";
export var spinner = "_1e-d";
export var squared = "_1e-8";
export var wrapText = "_1e-g";
export var xl = "_1e-5";
export var xs = "_1e-1";
export var xxl = "_1e-6";
export var xxxl = "_1e-7";